module.exports = __webpack_public_path__ + "static/media/img-mystery-box.1a4e9bf0.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@bit/fabfitfun.shared.global.layout-reader/node_modules/@bit/fabfitfun.my-box.global.my-box-header/dist/Box/img-mystery-box.svg
// module id = 650
// module chunks = 0